import { request } from "../utils/request";
//登录
import { versionfn } from "../utils/version";
var version = versionfn.version;
//新增用户反馈
export function globalResource(data) {
  return request({
    url: `${version}/resourceconfig/findConfigBySite`,
    method: "post",
    data,
  });
}

// 上报接口
export function report(data) {
  return request({
    url: `/system/report`,
    method: "post",
    data,
  });
}
//站点配置接口

export function globalsiteConfig(data) {
  return request({
    url: `${version}/site/config/query`,
    method: "post",
    data,
  });
} 